import router from "@/router";

export function handleResponseErrorMessage(err) {
  if (err.response === undefined) {
    return err;
  } else if (err.response.status === 404) {
    router.push({ name: "PageNotFound" });
  } else if (err.response.status === 500) {
    router.push({ name: "ServerError" });
  } else {
    return err;
  }
}
